import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var AppBarService = /** @class */ (function () {
    function AppBarService() {
        this.titleAppBar = new BehaviorSubject(null);
    }
    AppBarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppBarService_Factory() { return new AppBarService(); }, token: AppBarService, providedIn: "root" });
    return AppBarService;
}());
export { AppBarService };
